package com.shadowings.gero.data.lessons.placeholders
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs1Content
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs1QuizContent
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs2Content
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs2QuizContent


import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word

fun getHieroVerbsContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IExplanation> {
    return getHieroVerbs1Content(hiero, words, languageCode) + getHieroVerbs2Content(hiero, words, languageCode)
}

fun getHieroVerbsQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return getHieroVerbs1QuizContent(hiero, words, languageCode) + getHieroVerbs2QuizContent(hiero, words, languageCode)
}
